import { ZoomAdminManagedOAuthPage } from '@features/zoom-admin-managed/components/ZoomAdminManagedOAuthPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/_zoomRollout/zoom/callback')({
  component: ZoomAdminManagedOAuthPage,
});
